import React from 'react';

import './trustmark.less';
import trustmarks_data from '../../utils/trustmarksData';

function TrustMark() {
  const renderSwitch = () => {
    const parsedSiteID = parseInt(window.siteId, 10);
    switch (parsedSiteID) {
      case 1: // Denmark
      case 10: // Sweden
      case 12: // Norway
      case 13: // Finland
      case 22: // Austria
      case 14:
        return <Trustmarks items={trustmarks_data[parsedSiteID]} />; // Netherlands
      case 15:
        return (
          <>
            <Trustmarks items={trustmarks_data[parsedSiteID]} />
            <TrustedShops />
          </>
        ); // Germany
      case 16:
        return <TrustedShops />; // France
      case 11: // International (COM)
      default:
        return null;
    }
  };

  return (
    <div id="trustmark" className="trustmark">
      {renderSwitch()}
    </div>
  );
}

function SvgTrustMark({ site, url }) {
  return url ? (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <div className={site} />
    </a>
  ) : (
    <div className={site} />
  );
}

function ImgTrustMark({ src, alt, url }) {
  return url ? (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img loading="lazy" src={src} alt={alt} />
    </a>
  ) : (
    <img loading="lazy" src={src} alt={alt} />
  );
}

function Trustmarks({ items }) {
  return items
    .filter((item) => item.online)
    .map((item) =>
      item.type === 'svg' ? (
        <SvgTrustMark key={item.name} site={item.name} url={item.url} />
      ) : (
        <ImgTrustMark
          key={item.name}
          src={item.src}
          alt={item.alt}
          url={item.url}
        />
      )
    );
}

function TrustedShops() {
  return <div className="trusted-shops" />;
}

export default TrustMark;
